import { RequiredRule, Validator } from 'devextreme-react/validator';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, CompanyTypes, OrderStatus } from '../../../../types/enums';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { formatShortDate } from '../../../../utils/date-utils';
import { TextBoxWithDelay } from '../../../../components';
import { POInvoiceContext } from '../context/POInvoiceContext';
import { Link, useSearchParams } from 'react-router-dom';
import { formatNumber } from 'devextreme/localization';
import { useAuth } from '../../../../contexts/auth';

export default function InvoiceDatesPanel() {

	const { order } = useContext(PurchaseOrderContext);
	const { invoice, modify } = useContext(POInvoiceContext);
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const isOrderReadonly = order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	const { user } = useAuth();
	const isManufacturer = user?.companyTypeId === CompanyTypes.MFR;
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;
	const urlFolder = isManufacturer ? "manufacturer" : isServiceProvider ? "service-provider" : "distributor";

	return (
		<Panel header={'Dates'} >
			{
				order.details.deliveryFlow ?
					<>
						<Field label={'Requested Delivery Date'} >
							{formatShortDate(order.details.requestedDeliveryDate)}
						</Field>
						<Field label={'Validated Delivery Date'} >
							{formatShortDate(order.details.validatedDeliveryDate)}
						</Field>
						<Field label="Verified Delivery Date" >
							{formatShortDate(order.details.deliveredDate)}
						</Field>
					</>
					:
					!isServiceProvider ?
						<>
							<Field label="Requested Ship Date">
								{formatShortDate(order.details.requestedShipDate)}
							</Field>
							<Field label="Validated Ship Date" >
								{formatShortDate(order.details.validatedShipDate)}
							</Field>
							<Field label="Actual Ship Date" >
								{formatShortDate(order.details.actualShipDate)}
							</Field>
						</>
						:
						<>
							<Field label="Order Date">
								{formatShortDate(order.details.retailOrder.roDate)}
							</Field>
							<Field label="Template Date">
								{formatShortDate(order.details.retailOrder.enterTemplateDate)}
							</Field>
							<Field label="Scheduled Install Date">
								{formatShortDate(order.details.retailOrder.scheduledInstallDate)}
							</Field>
							<Field label="Actual Install Date">
								{formatShortDate(order.details.retailOrder.actualInstallDate)}
							</Field>
							<Field label="Service Initiated Date">
								{formatShortDate(order.details.serviceInitiatedDate)}
							</Field>
						</>
			}
			<Field label="Invoice Date" visible={!!invoice.details.invoiceDate}>
				{formatShortDate(invoice.details.invoiceDate)}
			</Field>
			<Field label="Distributor Invoice Number" >
				{
					order.details.activeARs.includes(AR.PODistributorToInvoice) ||
						order.details.activeARs.includes(AR.POServiceProviderToInvoice) ?
						<TextBoxWithDelay
							value={invoice.details.invoiceNumber}
							onTextChanged={(value) => modify({ ...invoice.details, invoiceNumber: value })}
							textChangeDelay={500}
							className='required'
							disabled={isOrderReadonly}
						>
							<Validator>
								<RequiredRule message={'Invoice number is required'} />
							</Validator>
						</TextBoxWithDelay>
						: order.details.invoices.length > 1 ?
							<table className='invoices'>
								<tbody>
									{
										order.details.invoices.map((inv) => {
											return (
												<tr key={inv.poInvoiceID}>
													<td className='invoice-selector'>
														{inv.poInvoiceID === invoice.details.poInvoiceID ? "➤" : ""}
													</td>
													<td>
														<Link to={`/${urlFolder}/purchase-order/` + order.details.purchaseOrderID + '/360/' + inv.poInvoiceID +
															(!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
															{inv.invoiceNumber}
														</Link>
													</td>
													<td>
														{formatNumber(inv.invoiceTotal, { type: 'currency', precision: 2 })}
													</td>
												</tr>)
										})
									}
									<tr>
										<td></td>
										<td></td>
										<td className='invoice-total'>
											{formatNumber(order.details.invoices.reduce((a, b) => a + b.invoiceTotal, 0), { type: 'currency', precision: 2 })}
										</td>
									</tr>
								</tbody>
							</table>
							:
							<>{invoice.details.invoiceNumber}</>
				}
			</Field>
		</Panel >
	);
}
